<template>
  <v-dialog v-model="dialog" width="500">
    <v-card>
      <v-card-title class="text-h5 grey lighten-2 mb-5">
        Selecione {{ isPolivalencia && !isInterdisciplinar ? "a Disciplina e a Etapa" : "a Etapa" }}
      </v-card-title>

      <v-card-text>
        <v-select
          id="escolha-bimestre.disciplina"
          v-if="isPolivalencia && !isInterdisciplinar"
          :items="disciplinas"
          item-text="descricao"
          item-value="id"
          v-model="disciplinaSelecionada"
          label="Selecione uma disciplina"
          solo
        >
          <template #item="{ item, on, attrs }">
            <v-list-item
              v-bind="attrs"
              v-on="on"
              :id="`escolha-bimestre.disciplina-item-${item.id}`"
            >
              <v-list-item-title>{{ item.descricao }}</v-list-item-title>
            </v-list-item>
          </template>
        </v-select>

        <v-select
          id="escolha-bimestre.etapa"
          :items="etapas"
          item-text="descricao"
          item-value="id"
          v-model="etapa_id"
          label="Selecione a etapa"
          solo
          no-data-text="Turma sem circuito cadastrado"
        >
          <template #item="{ item, on, attrs }">
            <v-list-item v-bind="attrs" v-on="on" :id="`escolha-bimestre.etapa-item-${item.id}`">
              <v-list-item-title>{{ item.descricao }}</v-list-item-title>
            </v-list-item>
          </template>
        </v-select>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn id="escolha-bimestre.cancelar" text @click="cancelar">Cancelar</v-btn>
        <v-btn
          id="escolha-bimestre.confirmar"
          color="primary"
          :disabled="isDisabled"
          @click="emitirDados"
          >OK</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    gestaoId: Number,
    disciplinas: Array,
    isPolivalencia: Boolean,
    isInfantil: Boolean,
    isInterdisciplinar: Boolean,
    disciplinaId: Number,
    etapas: Array,
  },
  data() {
    return {
      disciplinaSelecionada: null,
      etapa_id: null,
    };
  },
  watch: {
    dialog(val) {
      this.$emit("status", val);
    },
  },
  computed: {
    isDisabled() {
      return (
        this.etapa_id === null ||
        (this.isPolivalencia && !this.isInterdisciplinar && this.disciplinaSelecionada === null)
      );
    },
  },
  methods: {
    cancelar() {
      this.disciplinaSelecionada = null;
      this.etapa_id = null;
      this.$emit("status", false);
    },
    emitirDados() {
      const disciplinaId = this.isPolivalencia ? this.disciplinaSelecionada : this.disciplinaId;

      if (this.isInterdisciplinar) {
        this.$emit("confirmarInterdisciplinar", {
          gestaoId: this.gestaoId,
          etapa_id: this.etapa_id,
        });
      } else if (this.isInfantil) {
        this.$emit("confirmarInfantil", {
          gestaoId: this.gestaoId,
          etapa_id: this.etapa_id,
        });
      } else {
        this.$emit("confirmar", {
          gestaoId: this.gestaoId,
          etapa_id: this.etapa_id,
          disciplinaId,
        });
      }
      this.cancelar();
    },
  },
};
</script>
